import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateUserPowerBiReportsDetailWrapper = styled.div`
  .user-role-email-report-grid {
    padding: 0 16px 30px 16px;

    ${responsive.MOBILE`
      padding: 0 16px 24px 16px;
    `}
  }

  .MuiAccordionSummary-expandIconWrapper {
    display: none;
  }

  .accordion-container {
    padding: 0 16px 0 16px;

    .role-header-text {
      margin-top: 24px;
      color: ${COLORS.cirrus_black10};
    }
  }

  .MuiAccordionDetails-root {
    padding-bottom: 30px;

    ${responsive.MOBILE`
      padding-bottom: 16px;
    `}
  }

  .add-reports {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 24px;

    .edit-buttons {
      display: flex;
      gap: 16px;
      justify-content: flex-end;
      align-items: center;
    }
  }

  .reports-table {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .comments-section {
    margin-bottom: 16px;
  }
`;
